import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import SchoolIcon from "@mui/icons-material/School";

import { StyledSwitch } from "../Base";
import Button from "../Button";

const UserRow = ({ user, onInvoiceChange, onShowCertificates }) => {
  return (
    <TableRow className="custom-row">
      <TableCell>{user.id}</TableCell>
      <TableCell>{user.fullname}</TableCell>
      <TableCell>{user.email}</TableCell>
      <TableCell>{user.crews.map((c) => c.name).join(", ")}</TableCell>
      <TableCell>{user.country}</TableCell>
      <TableCell>{user.status}</TableCell>
      <TableCell className="t-none">
        <StyledSwitch
          title="Change invoice status"
          checked={user.payWithInvoice === 1}
          onChange={() => onInvoiceChange(user.id, user.payWithInvoice === 1 ? 0 || null : 1)}
        />
      </TableCell>
      <TableCell className="t-none">
        <Button
          title="All Completed Courses/Certificates"
          onClick={() => onShowCertificates(user.id)}
          icon={<SchoolIcon />}
        />
      </TableCell>
    </TableRow>
  );
};

export default UserRow;
